<template>
  <div class="card p-4">
    <div class="card-body">
      <div class="form-profile" v-if="modifyNote === false">
        <div class="middle">
          <textarea placeholder="Écrivez quelque chose... " v-model="formNote.text"> </textarea>
        </div>
        <div class="bottom">
          <div class="left"></div>
          <div class="right">
            <div @click="createNote()" class="btn-action-two" v-if="loadedPost">
              <p>Ajouter</p>
            </div>
            <div v-else class="d-flex justify-content-center align-items-center">
              <b-spinner variant="primary" style="width: 1.6rem; height: 1.6rem"></b-spinner>
            </div>
          </div>
        </div>
      </div>
      <div class="form-profile" v-if="modifyNote === true">
        <div class="middle">
          <textarea placeholder="Écrivez quelque chose..." v-model="formModifyNote.text"> </textarea>
        </div>
        <div class="bottom">
          <div class="left"></div>
          <div class="right">
            <div @click="cancelModifyNote" class="btn-action-dark">
              <p>Annuler</p>
            </div>
            <div @click="editNote(formModifyNote.id)" class="btn-action-two">
              <p>Modifier</p>
            </div>
          </div>
        </div>
      </div>
      <div v-if="loadedGet">
        <div class="mt-5">
          <div class="profile-section" :class="{ active: pinedNote }">
            <div class="header">
              <div class="top-title">
                <i class="bx bx-pin bx-sm"></i>
                NOTES ÉPINGLÉES
                <span></span>
              </div>
              <i class="arrow mdi mdi-chevron-down" @click="turnPinedNote"></i>
            </div>
            <div class="contentt">
              <div class="profile-component" v-for="(note, index) in pinedNotes" :key="note.id">
                <div class="desc" v-html="note.text"></div>
                <div class="bottom">
                  <div class="bottom-group">
                    <i class="mdi mdi-clock-outline"></i>
                    <p>{{ note.user_first_name }} {{ note.user_last_name }}</p>
                    <p>{{ note.made_at | formatDate }}</p>
                  </div>
                </div>
                <div class="buttons-modify">
                  <i class="bx bx-trash-alt" @click="deleteNote(note, index)"></i>
                  <i class="bx bx-edit-alt" @click="modifyNoteFunction(note)"></i>
                  <i class="bx bx bx-pin" @click="unpinNoteFunction(index)">
                    <span></span>
                  </i>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="mt-5">
          <div class="profile-section" :class="{ active: addedNote }">
            <div class="header">
              <div class="top-title">
                <i class="mdi mdi-note-text-outline bx-sm"></i>
                NOTES AJOUTÉES
                <span></span>
              </div>
              <i class="arrow mdi mdi-chevron-down" @click="turnAddedNote"></i>
            </div>
            <div class="contentt">
              <div class="profile-component" v-for="(note, index) in unpinedNotes" :key="note.id">
                <div class="desc" v-html="note.text"></div>
                <div class="bottom">
                  <div class="bottom-group">
                    <i class="mdi mdi-clock-outline"></i>
                    <p>{{ note.user_first_name }} {{ note.user_last_name }},</p>
                    <p>{{ note.made_at | formatDate }}</p>
                  </div>
                </div>
                <div class="buttons-modify">
                  <i class="bx bx-trash-alt" @click="deleteNote(note, index)"></i>
                  <i class="bx bx-edit-alt" @click="modifyNoteFunction(note)"></i>
                  <i class="bx bx bx-pin" @click="pinNoteFunction(index)"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="d-flex justify-content-center align-items-center mt-5">
        <b-spinner variant="primary" style="width: 3rem; height: 3rem"></b-spinner>
      </div>
    </div>
  </div>
</template>

<script>
import { User, APIRequest, Note } from '@/node-sdk'
import moment from 'moment'

export default {
  name: 'note',

  props: {
    baseUrl: {
      type: String,
      required: true,
    },
    noteRoute: {
      type: String,
      required: true,
    },
    entity: {
      type: String,
      required: true,
    },
    entityId: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      displayNotes: [],
      loadedPost: true,
      loadedGet: false,
      users: [],
      formNote: {
        text: null,
        pin: false,
      },
      formNoteInitial: {
        text: null,
        pin: false,
        user: null,
      },
      modifyNote: false,
      formModifyNote: {
        text: null,
        pin: false,
        user: null,
      },
      unpinedNotes: [],
      pinedNotes: [],
      pinedNote: true,
      addedNote: true,
    }
  },

  filters: {
    formatDate: function (date) {
      return moment(date).format('D/MM/YYYY')
    },
  },

  async mounted() {
    await this.getUsers()
    await this.getNotes()
  },

  methods: {
    onPageChange() {
      this.startIndex = (this.page - 1) * this.perPage
      this.endIndex = (this.page - 1) * this.perPage + this.perPage
      this.getMilestone(this.page)
    },

    async getUsers() {
      this.users = await User.get_users()
    },

    getUser() {
      let user_object = localStorage.getItem('user_object')
      return JSON.parse(user_object).uuid
    },

    getUserFirstName() {
      let user_object = localStorage.getItem('user_object')
      return JSON.parse(user_object).first_name
    },

    getUserLastName() {
      let user_object = localStorage.getItem('user_object')
      return JSON.parse(user_object).last_name
    },

    async getNotes() {
      this.loadedGet = false
      this.notes = await APIRequest.get_with_request(this.baseUrl, this.noteRoute, `?${this.entity}=${this.entityId}`)
      this.notes = this.notes[0]
      this.formatNotes()
      this.loadedGet = true
    },

    async createNote() {
      this.loadedPost = false
      this.formNote[this.entity] = this.entityId
      this.formNote.user = this.getUser()
      let note = await APIRequest.create(this.baseUrl, this.noteRoute, this.formNote)
      note.user_first_name = this.getUserFirstName()
      note.user_last_name = this.getUserLastName()
      this.unpinedNotes.push(note)
      this.formNote = Note.get_form_note()
      this.loadedPost = true
    },

    turnAddedNote() {
      this.addedNote = !this.addedNote
    },

    turnPinedNote() {
      this.pinedNote = !this.pinedNote
    },

    async deleteNote(note, index) {
      if (!note.pin) {
        this.$delete(this.unpinedNotes, index)
      } else {
        this.$delete(this.pinedNotes, index)
      }
      await APIRequest.delete(this.baseUrl, this.noteRoute, note.id)
    },

    formatNotes() {
      for (let i = 0; i < this.notes.length; i++) {
        for (let j = 0; j < this.users.length; j++) {
          if (this.notes[i].user === this.users[j].uuid) {
            this.notes[i].user_first_name = this.users[j].first_name
            this.notes[i].user_last_name = this.users[j].last_name
          }
        }
        if (this.notes[i].pin === false) {
          this.unpinedNotes.push(this.notes[i])
        } else {
          this.pinedNotes.push(this.notes[i])
        }
      }
    },

    async editNote(id) {
      await APIRequest.edit(this.baseUrl, this.noteRoute, id, this.formModifyNote)
      this.modifyNote = false
      this.formModifyNote = Note.get_form_note()
    },

    modifyNoteFunction(note) {
      window.scrollTo({ top: 0, behavior: 'smooth' })
      this.formModifyNote = note
      this.modifyNote = true
    },

    async pinNoteFunction(index) {
      this.formModifyNote = this.unpinedNotes[index]
      this.formModifyNote.pin = true
      this.pinedNotes.push(this.unpinedNotes[index])
      this.$delete(this.unpinedNotes, index)
      await this.editNote(this.formModifyNote.id)
    },

    async unpinNoteFunction(index) {
      this.formModifyNote = this.pinedNotes[index]
      this.formModifyNote.pin = false
      this.unpinedNotes.push(this.pinedNotes[index])
      this.$delete(this.pinedNotes, index)
      await this.editNote(this.formModifyNote.id)
    },

    cancelModifyNote() {
      this.modifyNote = false
    },
  },
}
</script>

<style scoped></style>
